export default __webpack_public_path__ + "static/media/p3.b6d98418.jpg";